/**
 * Types TypeScript centralisés pour la page Inventaire
 * Source unique de vérité selon Directive #2
 */

export type ItemSource = "pos" | "manuel";
export type ItemType = "produit_simple" | "recette" | "ingredient" | "non_defini";

export interface DeliveryInfo {
  orderId: string;         // ID de la commande
  supplierName: string;    // Nom du fournisseur
  estimatedDate: string;   // Date estimée de livraison
  quantity: number;        // Quantité en transit
}

export interface RecipeIngredient {
  itemId: string;       // ID de l'item ingrédient
  nom: string;          // Nom de l'ingrédient
  quantite: number;     // Quantité nécessaire
  unite: string;        // Unité de mesure (ml, g, unité, etc.)
  prixCoutant?: number; // Coût unitaire de l'ingrédient
}

export interface InventoryItem {
  id: string;
  nom: string;
  categorie: string;
  image: string;
  prixVente: number;
  prixCoutant: number;
  quantite: number;
  statut: "Actif" | "Inactif";
  source: ItemSource;  // NOUVEAU: provenance de l'item
  typeItem: ItemType;  // NOUVEAU: type de l'item
  recetteId?: string;  // NOUVEAU: lien vers la recette si applicable
  composition?: RecipeIngredient[];  // NOUVEAU: composition si c'est une recette
  inCart?: boolean;
  deliveryInfo?: DeliveryInfo;  // NOUVEAU: informations de livraison si en transit
  formatQuantite?: number;  // NOUVEAU: quantité par unité (ex: 750 pour une bouteille de 750ml)
  formatUnite?: string;     // NOUVEAU: unité de mesure du format (ml, g, oz, etc.)
  seuilStock?: number;      // NOUVEAU: seuil de stock bas personnalisé (utilise LOW_STOCK_THRESHOLD si non défini)
  seuilRupture?: number;    // NOUVEAU: seuil de rupture de stock personnalisé (0 si non défini)
  recipeUseCount?: number;
  supplierCount?: number;
  recipeNames?: string[];
  supplierDetails?: { name: string; unitCost: number | null; isPreferred: boolean }[];
}

export type StockFilter = "tous" | "rupture" | "bas" | "ok" | "commander";
export type MargeFilter = "" | "negative" | "faible" | "bonne";
export type TypeFilter = "" | "produit_simple" | "recette" | "ingredient" | "non_defini";  // NOUVEAU
export type SourceFilter = "" | "pos" | "manuel";  // NOUVEAU
export type SortDirection = "asc" | "desc";

export interface VisibleColumns {
  image: boolean;
  nom: boolean;
  categorie: boolean;
  source: boolean;    // NOUVEAU
  typeItem: boolean;  // NOUVEAU
  quantite: boolean;
  prixVente: boolean;
  prixCoutant: boolean;
  marge: boolean;
  statut: boolean;
}

export interface InventoryStats {
  totalValue: number;
  totalItems: number;
  lowStockCount: number;
  outOfStockCount: number;
  inCartCount: number;
  averageMargin: number;
}

export const CATEGORIES = [
  "Bières",
  "Cocktails",
  "Vins",
  "Boissons",
  "Collations",
  "Nourriture",
] as const;

export const LOW_STOCK_THRESHOLD = 10;